import React, { useEffect, useState } from "react";

import { COLUMNS } from './columns'
import Table from "../../common/Table/Table";
import AddUserButton from "../../common/AddUserButton/AddUserButton";
import Modal from "../../common/Modal/Modal";
import ClientsForm from "../../forms/ClientsForm/ClientsForm";
import { PencilIcon, DocumentReportIcon, TrashIcon } from '@heroicons/react/outline'
import ClientService from "../../../services/ClientService";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

const Clients = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [shouldLoad, setShouldLoad] = useState(true)
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [userData, setUserData] = useState({})
    const [modalTitle, setModalTitle] = useState('')
    const [buttonText, setButtonText] = useState('Dodaj Klijenta')
    const [clientsData, setClientsData] = useState(null)
    const [clientView, setClientView] = useState(null)


    useEffect(() => {
        if (shouldLoad) {
            setShouldLoad(false)
            getClients();
        }
    }, [shouldLoad])

    const getClients = () => {
        ClientService.getClients().then((response) => {
            setClientsData(response.data);
        });
    };

    const deleteClients = (client) => {
        MySwal.fire({
            showCancelButton: true,
            showDenyButton: true,
            showConfirmButton: false,
            denyButtonText: `Obriši`,
            cancelButtonText: `Otkaži`,
        }).then((result) => {
            if (result.isDenied) {
                ClientService.deleteClient(client.id).then(() => {
                    setShouldLoad(true)
                });
            }
        })

    };

    const addClient = (userData, formValues) => {
        let tempForm = { ...formValues, id: userData.id }
        if (tempForm.id) {
            ClientService.updateClient(tempForm).then(() => {
                setShouldLoad(true)
            });
        } else {
            ClientService.addClient(tempForm).then(() => {
                setShouldLoad(true)
            });
        }

    }

    // Prikaz jedne grupe vrednosti iz sifarnika kao "cipova"; ako lista jos nije
    // popunjena, prikazuje se stari tekstualni upis
    const tagChips = (label, list, oldValue) => {
        const hasList = Array.isArray(list) && list.length > 0;
        if (!hasList && !(oldValue && String(oldValue).trim())) return null;
        return (
            <div className="flex flex-col mr-8 mb-4">
                <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">{label}</span>
                {hasList ?
                    <div className="flex flex-wrap gap-1">
                        {list.map((item, i) => (
                            <span key={i} className="px-3 py-1 rounded-full text-xs font-medium bg-bluePrimary/10 text-gray-700 border border-bluePrimary/30">{item}</span>
                        ))}
                    </div>
                    :
                    <span className="text-sm text-gray-400 italic">Stari upis: {oldValue}</span>
                }
            </div>
        );
    };

    const showClient = () => {
        return <>
            <h3 className='text-center py-2 bg-bluePrimary text-white shadow-md font-medium  font-semibold'>{clientView.name}</h3>
            <div className="overflow-auto  px-4">
                <div className="flex flex-wrap mt-6">
                    {tagChips('Cilj', clientView.goalList, clientView.goal)}
                    {tagChips('Dijagnoze', clientView.diagnosisList, clientView.healthIssues)}
                    {tagChips('Alergije', clientView.allergyList, clientView.allergiesString)}
                    {tagChips('Intolerancije', clientView.intoleranceList, clientView.foodIntolerance)}
                    {tagChips('Lekovi', clientView.medicineList, clientView.medicines)}
                    {tagChips('Ne voli', clientView.dislikedFoodList, clientView.dislikesFood)}
                    {tagChips('Voli', clientView.likedFoodList, clientView.likesFood)}
                </div>
                <table className="w-full mt-2 lg:table-fixed">
                    <tbody>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Broj kartice</span>
                                    {
                                        clientView.personalCardNumber ? clientView.personalCardNumber : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Email</span>
                                    {
                                        clientView.email ? clientView.email : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Broj telefona</span>
                                    {
                                        clientView.phoneNumber ? clientView.phoneNumber : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Visina</span>
                                    {
                                        clientView.height ? clientView.height : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Težina</span>
                                    {
                                        clientView.weight ? clientView.weight : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Alergije</span>
                                    {
                                        clientView.allergiesString ? clientView.allergiesString : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Datum rođenja</span>
                                    {
                                        clientView.birthday ? formatDate(clientView.birthday) : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Problemi sa krvnim pritiskom</span>
                                    {
                                        clientView.bloodPressureIssues ? clientView.bloodPressureIssues : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Hrana koju ne voli</span>
                                    {
                                        clientView.dislikesFood ? clientView.dislikesFood : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Doji</span>
                                    {
                                        clientView.breastFeeding ? clientView.breastFeeding : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Može da donese hranu u školu</span>
                                    {
                                        clientView.canBringFoodToSchool ? clientView.canBringFoodToSchool : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Može da donese hranu na posao</span>
                                    {
                                        clientView.canBringFoodToWork ? clientView.canBringFoodToWork : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Kafa</span>
                                    {
                                        clientView.coffee ? clientView.coffee : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Problemi sa opstipacijom</span>
                                    {
                                        clientView.constipationIssues ? clientView.constipationIssues : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Datum</span>
                                    {
                                        clientView.date ? clientView.date : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Opis dana</span>
                                    {
                                        clientView.dayDescription ? clientView.dayDescription : '/'
                                    }
                                </div>
                            </td>

                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Opis doručka</span>
                                    {
                                        clientView.breakfastDescription ? clientView.breakfastDescription : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Opis ručka</span>
                                    {
                                        clientView.lunchDescription ? clientView.lunchDescription : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Opis večere </span>
                                    {
                                        clientView.dinnerDescription ? clientView.dinnerDescription : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Intolerancija na hranu</span>
                                    {
                                        clientView.foodIntolerance ? clientView.foodIntolerance : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Cilj</span>
                                    {
                                        clientView.goal ? clientView.goal : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Alergije</span>
                                    {
                                        clientView.hasAllergies ? clientView.hasAllergies : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Ima pauze</span>
                                    {
                                        clientView.hasBreaks ? clientView.hasBreaks : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Problemi sa zdravljem</span>
                                    {
                                        clientView.healthIssues ? clientView.healthIssues : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Da li kuva</span>
                                    {
                                        clientView.isCookingString ? clientView.isCookingString : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Zaposlenje</span>
                                    {
                                        clientView.isEmployed ? clientView.isEmployed : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Broj obroka</span>
                                    {
                                        clientView.numberOfMeals ? clientView.numberOfMeals : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Opis užine</span>
                                    {
                                        clientView.snackDescription ? clientView.snackDescription : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Pušač</span>
                                    {
                                        clientView.isSmoker ? clientView.isSmoker : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Student</span>
                                    {
                                        clientView.isStudent ? clientView.isStudent : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Radi u noćnim smenama</span>
                                    {
                                        clientView.isWorkingNightShifts ? clientView.isWorkingNightShifts : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Posao / Radni sati</span>
                                    {
                                        clientView.job ? clientView.job : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Hrana koju voli</span>
                                    {
                                        clientView.likesFood ? clientView.likesFood : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Pol</span>
                                    {
                                        clientView.gender ? clientView.gender : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Lekovi</span>
                                    {
                                        clientView.medicines ? clientView.medicines : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Beleška</span>
                                    {
                                        clientView.note ? clientView.note : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Fizički je aktivan/na</span>
                                    {
                                        clientView.isPhysicallyActive ? clientView.isPhysicallyActive : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Fizička aktivnost</span>
                                    {
                                        clientView.physicalActivity ? clientView.physicalActivity : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Količina fizičke aktivnosti</span>
                                    {
                                        clientView.physicalActivityAmount ? clientView.physicalActivityAmount : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Dani fizičke aktivnosti</span>
                                    {
                                        clientView.physicalActivityDays ? clientView.physicalActivityDays : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Intenzitet fizičke aktivnosti</span>
                                    {
                                        clientView.physicalActivityIntensity ? clientView.physicalActivityIntensity : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Vreme fizičke aktivnosti</span>
                                    {
                                        clientView.physicalActivityTime ? clientView.physicalActivityTime : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Trudna</span>
                                    {
                                        clientView.isPregnant ? clientView.isPregnant : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Mesec trudnoće</span>
                                    {
                                        clientView.pregnancyMonth ? clientView.pregnancyMonth : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Telesna težina dobijena u toku trudnoće</span>
                                    {
                                        clientView.pregnancyWeightGain ? clientView.pregnancyWeightGain : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Težina na početku trudnoće</span>
                                    {
                                        clientView.pregnancyWeightStart ? clientView.pregnancyWeightStart : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Školski raspored</span>
                                    {
                                        clientView.schoolSchedule ? clientView.schoolSchedule : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Bezalkoholna pića</span>
                                    {
                                        clientView.softDrinks ? clientView.softDrinks : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Čaj</span>
                                    {
                                        clientView.tea ? clientView.tea : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Količina vode koju unosi</span>
                                    {
                                        clientView.waterAmount ? clientView.waterAmount : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Raspored rada</span>
                                    {
                                        clientView.workSchedule ? clientView.workSchedule : '/'
                                    }
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="py-4 px-2 md:px-5 pl-0 md:pl-0 font-medium align-baseline">
                                <div className="flex flex-col max-w-max min-w-[200px]">
                                    <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">Radi vikendom</span>
                                    {
                                        clientView.worksOnWeekends ? clientView.worksOnWeekends : '/'
                                    }
                                </div>
                            </td>
                            <td className="py-4 px-2 md:px-5 font-medium align-baseline">
                                {/* <div className="flex flex-col max-w-max min-w-[200px]">
                                <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">activity</span>
                                {
                                    clientView.physicalActivity ? clientView.physicalActivity : '/'
                                }
                            </div> */}
                            </td>
                            <td className="py-4 px-2 md:px-5 pr-0 md:pr-0 font-medium align-baseline">
                                {/* <div className="flex flex-col max-w-max min-w-[200px]">
                                <span className="pb-2 font-semibold text-xs text-gray-500 leading-none">activity</span>
                                {
                                    clientView.physicalActivityAmount ? clientView.physicalActivityAmount : '/'
                                }
                            </div> */}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </>
    };

    const openModal = (row) => {
        setUserData(row.original);
        setIsEditModalOpen(true);
        setModalTitle('Izmeni klijenta');
    };

    const additionalColumn = {
        Header: ' ',
        Cell: ({ row }) => (
            <div className="flex items-center justify-end">
                <span className="p-2 rounded-full transition cursor-pointer purpleGradient" title="Obriši" onClick={() => deleteClients(row.original)}><TrashIcon className="w-4 h-4 text-white transition" /></span>
            </div>
        )
    }
    return (
        <>
            <AddUserButton setIsOpen={setIsEditModalOpen} setUserData={setUserData} setModalTitle={setModalTitle} buttonText={buttonText} />
            {isEditModalOpen &&
                <Modal setIsOpen={setIsEditModalOpen} width="w-full sm:w-full md:max-w-[80vw] lg:max-w-[70vw]" modalContent={<ClientsForm setIsOpen={setIsEditModalOpen} userData={userData} modalTitle={modalTitle} addClient={addClient} clients={clientsData} />} />
            }
            {isPreviewModalOpen &&
                <Modal setIsOpen={setIsPreviewModalOpen} width="w-full sm:w-full md:max-w-[80vw] lg:max-w-[70vw]" modalContent={showClient()} />
            }
            {clientsData !== null ?
                <Table openModal={openModal} columnsProp={COLUMNS} dataProp={clientsData} additionalColumn={additionalColumn} setUserData={setUserData} setModalTitle={setModalTitle} />
                : null}
        </>
    )

};

export default Clients;
